import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Card, Row, Col } from "react-bootstrap";
import axios from 'axios';
import { var_api } from '../../../constant';
import { ToastContainer, toast, } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";

const PaymentModeMaster = () => {
  const tableHeaders = ["#", "Payment Mode", "Description", "Status", "Action"];
  const [paymodeData, setPaymodeData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  // State for Delete functionality
const [showDeleteModal, setShowDeleteModal] = useState(false);
const [deleteId, setDeleteId] = useState(null);
  const warehouseId = localStorage.getItem("warehouse_id") || 1;

  const [formData, setFormData] = useState({
    id: null,
    paymode_name: '',
    description: '',
    is_active: 1,
    is_delete: 0,
    warehouse_id: warehouseId
  });
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;
  const [initialLoading, setInitialLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    loadInitialData();
  }, []);

  const loadInitialData = async () => {
    try {
      setInitialLoading(true);
      await fetchPaymodeData();
    } catch (error) {
      toast.error("Error loading data");
    } finally {
      setInitialLoading(false);
    }
  };

  const fetchPaymodeData = async () => {
    try {
      const res = await axios.get(`${var_api}paymode_master/get-warehouseid/${warehouseId}`);
      setPaymodeData(res.data || []);
    } catch {
      toast.error("Failed to fetch payment mode data");
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    setErrors(prev => ({ ...prev, [name]: '' }));
  };

  const handleAddClick = () => {
    setFormData({ id: null, paymode_name: '', description: '', is_active: 1, is_delete: 0, warehouse_id: warehouseId });
    setIsEditMode(false);
    setErrors({});
    setShowModal(true);
  };

  const handleEditClick = (item) => {
    setFormData({ ...item });
    setIsEditMode(true);
    setErrors({});
    setShowModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};
    if (!formData.paymode_name.trim()) newErrors.paymode_name  = "Payment mode is required";
    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      toast.warning("Please correct the highlighted fields");
      return;
    }

    try {
      setLoading(true);
      let res;
      if (isEditMode && formData.id) {
        res = await axios.put(`${var_api}paymode_master/update/${formData.id}`, formData);
      } else {
        res = await axios.post(`${var_api}paymode_master/post`, formData);
      }

      toast.success(res?.data?.message || "Saved successfully!");
      setShowModal(false);
      setFormData({ id: null, paymode_name: '', description: '', is_active: 1, is_delete: 0 });
      fetchPaymodeData();
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to save record");
    } finally {
      setLoading(false);
    }
  };

  const filteredData = paymodeData.filter(item =>
    Object.values(item).some(val => String(val).toLowerCase().includes(searchQuery.toLowerCase()))
  );

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = filteredData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  return (
    <>
      <Card>
        <Card.Body>
          {initialLoading ? (
            <div className="text-center my-5">
              <div className="spinner-border text-primary" role="status"></div>
              <div>Loading data...</div>
            </div>
          ) : (
            <>
              <div className="d-flex justify-content-end mb-3 gap-2">
                <input
                  type="text"
                  className="form-control w-auto"
                  placeholder="Search..."
                  value={searchQuery}
                  onChange={e => {
                    setSearchQuery(e.target.value);
                    setCurrentPage(1);
                  }}
                />
                <Button variant="secondary" onClick={handleAddClick}>Add</Button>
              </div>

              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>{tableHeaders.map((header, idx) => (<th key={idx}>{header}</th>))}</tr>
                  </thead>
                  <tbody>
                    {paginatedData.length === 0 ? (
                      <tr>
                        <td colSpan="5" className="text-center text-muted py-3">No data found</td>
                      </tr>
                    ) : (
                      paginatedData.map((item, idx) => (
                        <tr key={item.id}>
                          <td>{(currentPage - 1) * itemsPerPage + idx + 1}</td>
                          <td>{item.paymode_name }</td>
                          <td>{item.description}</td>
                          <td>
                            <span className={`badge ${item.is_active === 1 ? 'bg-success' : 'bg-danger'}`}>
                              {item.is_active === 1 ? 'Active' : 'Inactive'}
                            </span>
                          </td>
                          <td >
                            <Link
                                                         to="#"
                                                         className="btn shadow btn-xs sharp me-1"
                                                         style={{
                                                           backgroundColor: "#007bff",
                                                           color: "white",
                                                         }}
                                                         onClick={() => handleEditClick(item)}
                                                       >
                                                         <i className="fas fa-pencil-alt"></i>
                                                       </Link>
                                                        <Link
    to="#"
    className="btn shadow btn-xs sharp"
    style={{ backgroundColor: "#dc3545", color: "white" }}
    onClick={() => {
      setDeleteId(item.id);
      setShowDeleteModal(true);
    }}
  >
    <i className="fas fa-trash"></i>
  </Link>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>

                <div className="d-flex justify-content-end mt-3">
                  {[...Array(totalPages)].map((_, idx) => (
                    <Button
                      key={idx}
                      variant={currentPage === idx + 1 ? "primary" : "light"}
                      onClick={() => setCurrentPage(idx + 1)}
                      className="me-1"
                    >
                      {idx + 1}
                    </Button>
                  ))}
                </div>
              </div>
            </>
          )}
        </Card.Body>

        {/* Modal */}
        <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
          <Modal.Header closeButton>
            <Modal.Title>{isEditMode ? "Edit Payment Mode" : "Add Payment Mode"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col md={6}>
                <Form.Group className="mb-3">
  <Form.Label>Payment Mode <span className="text-danger">*</span></Form.Label>
  <Form.Control
    type="text"
    name="paymode_name"
    value={formData.paymode_name}
    placeholder="Enter payment mode"
    onChange={handleInputChange}
  />
  {errors.paymode_name && (
    <div className="text-danger small mt-1">{errors.paymode_name}</div>
  )}
</Form.Group>

                </Col>

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Description</Form.Label>
                    <Form.Control
                      type="text"
                      name="description"
                      value={formData.description}
                      placeholder="Enter description"
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                </Col>

        {isEditMode && (
  <>
    <Col md={6}>
      <Form.Group className="mb-2 d-flex align-items-center gap-2">
        <Form.Label className="mb-0">
          {formData.is_active === 1 ? "Active" : "Inactive"}
        </Form.Label>
        <Form.Check
          type="switch"
          id="active-status-switch"
          checked={formData.is_active === 1}
          onChange={(e) =>
            setFormData({ ...formData, is_active: e.target.checked ? 1 : 0 })
          }
          className={formData.is_active === 1 ? "custom-switch-green" : ""}
        />
      </Form.Group>
    </Col>

    <Col md={6}>
      <Form.Group className="mb-2 d-flex align-items-center gap-2">
        <Form.Label className="mb-0">
          {formData.is_delete === 1 ? "Deleted" : "Not Deleted"}
        </Form.Label>
        <Form.Check
          type="switch"
          id="delete-status-switch"
          checked={formData.is_delete === 1}
          onChange={(e) =>
            setFormData({ ...formData, is_delete: e.target.checked ? 1 : 0 })
          }
          className={formData.is_delete === 1 ? "custom-switch-red" : ""}
        />
      </Form.Group>
    </Col>
  </>
)}

              </Row>

              <div className="d-flex justify-content-end gap-2">
                {!isEditMode ? (
                  <>
                    <Button variant="secondary" type="submit" disabled={loading}>
                      {loading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Creating...
                        </>
                      ) : (
                        "Create"
                      )}
                    </Button>
                    <Button
                      variant="danger"
                      type="reset"
                      onClick={() => setFormData({ id: null, paymode_name: '', description: '', is_active: 1, is_delete: 0 })}
                      disabled={loading}
                    >
                      Reset
                    </Button>
                  </>
                ) : (
                  <>
                    <Button variant="warning" type="submit" disabled={loading}>
                      {loading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Updating...
                        </>
                      ) : (
                        "Update"
                      )}
                    </Button>
                    <Button variant="danger" onClick={() => setShowModal(false)} disabled={loading}>
                      Cancel
                    </Button>
                  </>
                )}
              </div>
            </Form>
          </Modal.Body>
        </Modal>
<Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
  <Modal.Header closeButton>
    <Modal.Title>Confirm Delete</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    Are you sure you want to delete this payment mode?
  </Modal.Body>
  <Modal.Footer>
    <Button variant="danger" onClick={() => setShowDeleteModal(false)}>
      Cancel
    </Button>
    <Button
      variant="info"
      onClick={async () => {
        try {
          await axios.delete(`${var_api}paymode_master/delete/${deleteId}`);
          toast.success("Deleted successfully!");
          setShowDeleteModal(false);
          fetchPaymodeData(); // refresh table
        } catch (err) {
          toast.error(err?.response?.data?.message || "Failed to delete");
        }
      }}
    >
      Delete
    </Button>
  </Modal.Footer>
</Modal>
        <style>{`
        .custom-switch-green .form-check-input:checked {
  background-color: #28a745 !important;
  border-color: #28a745 !important;
}

.custom-switch-red .form-check-input:checked {
  background-color: #dc3545 !important;
  border-color: #dc3545 !important;
}

        `}</style>
      </Card>

      <ToastContainer />
    </>
  );
};

export default PaymentModeMaster;
